const loadingService = function () {
    this.loading = [];

    const startLoading = (param) => {
        if (Array.isArray(param)) {
            const returns = param.map(value => {
                return startLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }

        return startLoadingSingle(param);
    };

    const stopLoading = (param) => {
        if (Array.isArray(param)) {
            const returns = param.map(value => {
                return stopLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }

        return stopLoadingSingle(param);
    };

    const isLoading = (param) => {
        if (Array.isArray(param)) {
            const returns = param.map(value => {
                return isLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }
        return isLoadingSingle(param);
    };

    const clearLoading = () => {
        this.loading = [];
    };

    const startLoadingSingle = (param) => {
        if (this.loading.indexOf(param) === -1) {
            this.loading.push(param);
            return true;
        }

        return false;
    };

    const stopLoadingSingle = (param) => {
        const index = this.loading.indexOf(param);

        if (index > -1) {
            this.loading.splice(index, 1);
            return true;
        }

        return false;
    };

    const isLoadingSingle = (param) => {
        if (param) {
            return this.loading.indexOf(param) > -1;
        }

        return this.loading.length > 0;
    };

    return {
        startLoading,
        stopLoading,
        isLoading,
        clearLoading
    };
};

loadingService.$inject = [];

export default loadingService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/loading.service.js